module.exports = __webpack_public_path__ + "media/images/product/f_n-57876df97409b51f08f72f419f495c3e.png";